/** Format timestamp-backed dashboard matches in the viewer's browser timezone. */
export function localMatchTime<T extends { matchTime?: string | null; tournamentDate?: string | null; scheduledAt?: string | null }>(match: T): T {
  if (!match.matchTime || !/^\d{4}-\d{2}-\d{2}T/.test(match.matchTime)) return match;
  const date = new Date(match.matchTime);
  if (Number.isNaN(date.getTime())) return match;
  const pad = (value: number) => String(value).padStart(2, '0');
  return {
    ...match,
    scheduledAt: match.scheduledAt || match.matchTime,
    tournamentDate: `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`,
    matchTime: `${pad(date.getHours())}:${pad(date.getMinutes())}`,
  };
}
